import { Server } from './server';
import { Service, ServiceResponse } from './service';

export class NotificationsService extends Service {
  protected messages:any[];

  constructor() {
    super();
    this.messages = [];
  }

  public async init(): Promise<ServiceResponse> {
    return {success: true};
  }
  
  public getMessages() {
    return this.messages;
  }

  public async checkMessages() {
    if(!Server.account.isLoggedIn())
      return;

    let response = await this.sendCommand('user', 'get-notifications', {});

    if(response.status == 200) {
      this.messages = response.body.messages;
      this.notifyListeners('notification');
    }
  }

  public async loadMoreMessages() {
    let params = {before: this.messages[this.messages.length-1].date};
    let response = await this.sendCommand('user', 'get-notifications', params);
    if(response.status == 200)
      this.messages = this.messages.concat(response.body.messages);
  }

  protected onNotification(event:any) {
    let msg = {...event};
    delete msg.id;

    this.messages.unshift(msg);

    this.notifyListeners('notification', {message: msg});
  }
}
